export const AVATAR_GROUP_COUNTER_TOOLTIP_SHOW_DELAY = 200;
export const AVATAR_GROUP_COUNTER_AVATAR_SIZE = 22;
